import { render, staticRenderFns } from "./MyClassroomsPage.vue?vue&type=template&id=d324b782&scoped=true"
import script from "./MyClassroomsPage.vue?vue&type=script&lang=js"
export * from "./MyClassroomsPage.vue?vue&type=script&lang=js"
import style0 from "./MyClassroomsPage.vue?vue&type=style&index=0&id=d324b782&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d324b782",
  null
  
)

export default component.exports